<div class="free-form-text-editor" #editorContainer
     (mousedown)="$event.stopPropagation()"
     (touchstart)="$event.stopPropagation()">
  <!-- Empty State -->
  @if (editorState() === 'empty') {
    <div class="empty-state" (click)="onPencilClick()">
      <div class="empty-state-icon">
        <ui-icon name="pencil" class="stroke-gray-400 hover:stroke-blue-600 transition-colors" size="size-16"></ui-icon>
      </div>
      <p class="empty-state-text">Click to add text</p>
    </div>
  }

  <!-- Editing State -->
  @if (editorState() === 'editing') {
    <div class="editing-state">
      <div class="quill-container">
        <!-- Fixed Toolbar Container -->
        <div class="toolbar-container">
          <quill-editor
            #quillEditor
            [ngModel]="content()"
            (ngModelChange)="content.set($event)"
            [modules]="quillModules"
            [placeholder]="'Start typing...'"
            [formats]="['bold', 'italic', 'underline', 'strike', 'header', 'list', 'color', 'background', 'font', 'size', 'align', 'direction', 'indent', 'script', 'link', 'image', 'video', 'blockquote', 'code-block']"
            theme="snow"
            (onEditorCreated)="onEditorCreated()"
            class="quill-editor">
          </quill-editor>

          <!-- Light bulb icon positioned in toolbar -->
          <button
            class="lightbulb-button-in-toolbar"
            (click)="onLightbulbClick()"
            [title]="'AI Suggestions'">
            <ui-icon
              name="lightbulb"
              class="stroke-current"
              size="size-4">
            </ui-icon>
          </button>

          <!-- Custom save button positioned in toolbar -->
          <button
            class="save-button-in-toolbar"
            (click)="onSaveClick()"
            [disabled]="!canSave"
            [title]="isSaving() ? 'Saving...' : 'Save'">
            @if (!isSaving()) {
              <ui-icon
                name="save"
                class="stroke-current"
                size="size-4">
              </ui-icon>
            }
            @if (isSaving()) {
              <div class="three-dots-loader">
                <div class="dot dot1"></div>
                <div class="dot dot2"></div>
                <div class="dot dot3"></div>
              </div>
            }
            {{ isSaving() ? 'Saving' : 'Save' }}
          </button>

          <!-- Error message -->
          @if (saveError()) {
            <div class="error-message">
              {{ saveError() }}
            </div>
          }
        </div>
      </div>
    </div>
  }

  <!-- Viewing State -->
  @if (editorState() === 'viewing') {
    <div class="viewing-state">
      <quill-editor
        #quillViewerEditor
        [ngModel]="content()"
        [readOnly]="true"
        [modules]="readOnlyModules"
        theme="snow"
        class="quill-viewer">
      </quill-editor>
    </div>
  }
</div>
